import { render, staticRenderFns } from "./AccountPropertySection.vue?vue&type=template&id=067ce1e7&scoped=true"
import script from "./AccountPropertySection.vue?vue&type=script&lang=js"
export * from "./AccountPropertySection.vue?vue&type=script&lang=js"
import style0 from "./AccountPropertySection.vue?vue&type=style&index=0&id=067ce1e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067ce1e7",
  null
  
)

export default component.exports